import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ManagementComponent } from './management.component';
import { AreasComponent } from './components/areas/areas.component';
import { CountriesComponent } from './components/countries/countries.component';

const routes: Routes = [
  {
    path: '',
    component: ManagementComponent,
    children: [
      { path: '', redirectTo: 'areas', pathMatch: 'full' },
      { path: 'areas', component: AreasComponent },
      { path: 'countries', component: CountriesComponent },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ManagementRoutingModule {}
